/**
 * Zentrale Verwaltung von Kamera-/Mikrofon-Streams und Objekt-URLs, damit die Auto-Sperre
 * alles zuverlässig stoppen bzw. freigeben kann (ARCHITEKTUR §10.5).
 */
const streams = new Set<MediaStream>();
const urls = new Set<string>();

export async function getMedia(constraints: MediaStreamConstraints): Promise<MediaStream> {
  const s = await navigator.mediaDevices.getUserMedia(constraints);
  streams.add(s);
  return s;
}

export function stopMedia(s: MediaStream | null | undefined) {
  if (!s) return;
  s.getTracks().forEach((t) => t.stop());
  streams.delete(s);
}

export function trackObjectUrl(url: string) {
  urls.add(url);
  return url;
}

export function releaseObjectUrl(url: string) {
  URL.revokeObjectURL(url);
  urls.delete(url);
}

/** Alles stoppen und freigeben (Sperre, Vorgangsende) */
export function releaseAllMedia() {
  for (const s of [...streams]) stopMedia(s);
  for (const u of [...urls]) releaseObjectUrl(u);
}
